if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    connectedCallback() {
      this.addEventListener('change', (event) => {
        const target = this.getInputForEventTarget(event.target);
        MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, { data: { selectedOptionValues: this.selectedOptionValues, event, target } });
        
        // 变体切换时触发检查
        this.checkR5DynamicShipping();
      });

      // 页面首次加载时触发检查（轻微延迟以确保 DOM 渲染完成）
      setTimeout(() => {
        this.checkR5DynamicShipping();
      }, 100);
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }

    // ==== 新增定制逻辑：单独隔离 R5 5000W 的发货模块 ====
    checkR5DynamicShipping() {
      // 获取刚刚在 Liquid 中打上标记的 Shipping 模块
      const shippingBlock = document.querySelector('.skt-dynamic-shipping');
      if (!shippingBlock) return;

      const productHandle = shippingBlock.getAttribute('data-product-handle') || '';

      // 核心安全锁：判断当前页面是否为 R5
      // 只要 handle 不包含 "r5"（例如 Y3），直接 return，保证其他产品正常展示，绝对不受影响
      if (!productHandle.toLowerCase().includes('r5')) {
        shippingBlock.style.display = '';
        return;
      }

      let is5000WSelected = false;
      // 获取当前选中的选项（兼容按钮样式和下拉框样式）
      const selectedInputs = this.querySelectorAll('input[type="radio"]:checked, select');

      selectedInputs.forEach(input => {
        let value = input.value;
        if (input.tagName.toLowerCase() === 'select') {
          value = input.options[input.selectedIndex].text;
        }
        // 检索变体名称，无论大小写，只要包含 5000W 就判定为预售款
        if (value && value.toUpperCase().includes('5000W')) {
          is5000WSelected = true;
        }
      });

      // 执行动作：如果是 5000W 则隐藏，否则（1500W / 3000W）正常显示
      if (is5000WSelected) {
        shippingBlock.style.display = 'none';
      } else {
        shippingBlock.style.display = ''; 
      }
    }
  }
  customElements.define("variant-picker", VariantPicker);
}